export default __webpack_public_path__ + "static/media/T660_RoHS.3332f100.pdf";